import ProfilePicture from 'components/elements/ProfilePicture'
import { User } from 'interfaces/User'
import { DisplayChatMessage } from 'interfaces/UserChat'
import { useEffect, useState } from 'react'
import UserService from 'services/UserService'
import { Caption } from 'stories/elements/Typography/Text'
import styled from 'styled-components'

const MemberWrapper = styled.div`
    display: grid;
    grid-template-columns: auto 1fr;
    padding: 3px 0;
    place-content: center;
    gap: 5px;
    align-items: center;
    p {
        font-weight: 600;
    }
`

interface Props {
    message: DisplayChatMessage
    currentIndex: number
    allMessages: DisplayChatMessage[]
    groupMembers: User[] | undefined
}

const GroupMessageSender = ({ message, currentIndex, allMessages, groupMembers }: Props) => {
    const [groupMember, setGroupMember] = useState<User>()

    useEffect(() => {
        if (!groupMembers?.length) return

        if (allMessages[currentIndex - 1]?.userIdentification === message.userIdentification) return

        const member = groupMembers.find((member) => member.uuid === message.userIdentification)
        if (member) {
            setGroupMember(member)
        } else {
            UserService.get(message.userIdentification).then((u) => {
                setGroupMember(u)
            })
        }
    }, [allMessages, currentIndex, groupMembers, message.userIdentification])

    return (
        <>
            {groupMember ? (
                <MemberWrapper>
                    <ProfilePicture user={groupMember} size={25} />
                    <Caption>{groupMember.name}</Caption>
                </MemberWrapper>
            ) : null}
        </>
    )
}

export default GroupMessageSender
